/* eslint-disable import/prefer-default-export */

import { Organization, WithContext } from 'schema-dts';

export const structure: WithContext<Organization> = {
  '@type': 'Organization',
  '@context': 'https://schema.org',
  name: 'Structure Financial',
  logo: {
    '@type': 'ImageObject',
    url: 'https://structure.fi/apple-touch-icon.png',
  },
} as const;
